import Link from "next/link";

const BreadCrumbs = ({
  location,
  type,
}: {
  location?: string;
  type?: string;
}) => {
  return (
    <section id="bread-crumbs" className="px-2 pt-8 mx-auto text-sm max-w-7xl">
      <div className="flex flex-wrap lg:space-y-0">
        <div className="flex gap-2">
          <Link
            href="/"
            className="cursor-pointer text-my-dark-blue hover:underline"
          >
            <p className="">Home</p>
          </Link>
          <p>&gt;</p>
        </div>
        <div className="flex gap-2 pl-1">
          <Link
            href="/airports-in-united-states"
            className={`${
              type === "mid" ? "font-bold pointer-events-none" : ""
            } cursor-pointer text-my-dark-blue hover:underline`}
          >
            Car rentals in the United States Airports
          </Link>
          {type != "mid" && <p>&gt;</p>}
        </div>
        {type != "mid" && <p className="font-bold lg:pl-1">{location}</p>}
      </div>
    </section>
  );
};

export default BreadCrumbs;
